import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import { SEO } from "../SEO";
function TermsOfUse() {
  const [activeTab, setActiveTab] = React.useState<"terms" | "privacy">(
    "terms",
  );
  const navigate = useNavigate();
  return (
    <>
      <SEO
        title="Terms of Use | Afripay"
        description="Terms of Use on Afripay."
        canonical="https://goafripay.com/terms-of-use"
      />
      <Navbar />
      <div className="pt-16">
        {/* bg-[#0B7F47] */}
        <div className=" bg-[#001E0E] lg:px-14 px-6 md:pb-10 pb-10 mx-auto  flex flex-col lg:justify-center lg:space-x-14">
          <div className="place-self-center text-center md:pt-16 pt-8">
            <h1 className="md:text-5xl text-3xl text-[#fff] font-bold">
              Terms of Service
            </h1>

            <p className="md:mt-2 mt-2 md:text-base text-[#fff] text-sm">
              Last Update : 25-8-2025
            </p>

            {/* Tab Navigation */}
            <div className="flex justify-center items-center bg-[#0B7F47] pt-2 px-2 space-x-8 mt-10 rounded-[5px]">
              <button
                onClick={() => navigate("/terms-of-use")}
                className="text-white text-lg font-[400] pb-2 transition-all duration-300 border-b-2 border-white opacity-100"
              >
                Terms of Service
              </button>
              <button
                onClick={() => navigate("/privacy-policy")}
                className="text-white text-lg font-[400] pb-2 transition-all duration-300 opacity-70 hover:opacity-90"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Terms of Service */}
      <div className="lg:px-20 px-6 pt-12 pb-10">
        <div>
          <p className="text-[#475467] text-[16px] font-[300]">
            Welcome to AfriPay, a service provided by Afripro Platform Nigeria
            Ltd ("AfriPay", "we", "us", or "our"). These Terms and Conditions
            ("Terms") govern your access to and use of the AfriPay platform,
            including our website https://goafripay.com, mobile applications,
            APIs, and other related services (collectively, the "Services").
          </p>
          <p className="text-[#475467] text-[16px] font-[300] mt-4">
            By registering for, accessing, or using our Services, you agree to
            be bound by these Terms. If you do not agree to these Terms, please
            do not use the Services.
          </p>
        </div>

        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Eligibility</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            To use AfriPay, you must be at least 18 years old or the age of
            majority in your jurisdiction, and legally capable of entering into
            a binding agreement. You represent and warrant that all information
            you provide to us is truthful, accurate, and complete.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Account Registration
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            To access certain features, you must create an account. During
            registration, you agree to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of your login credentials</li>
            <li>
              Accept responsibility for all activities that occur under your
              account
            </li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We may suspend or terminate your account if we suspect any
            fraudulent activity or violation of these Terms.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Our Services
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay provides a comprehensive cross-border payment ecosystem
            tailored for African students, freelancers, migrants, and workers.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Virtual Wallet & Accounts
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Users may create virtual wallets and local/international virtual
            accounts to store funds and process transactions in multiple
            currencies. These accounts allow seamless transfers, deposits, and
            withdrawals.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Tuition Payments
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay simplifies international tuition payments by integrating
            directly with educational institutions. Users can securely pay
            tuition in local or foreign currency and receive confirmation and
            receipts.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Virtual and Physical Cards
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We offer virtual and physical debit/credit cards linked to your
            AfriPay wallet. These cards allow secure online and offline
            transactions globally.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Loan Services
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Loan ServiceEligible users can apply for education or
            migration-related loans directly through the platform. Loan
            disbursement, status tracking, and repayments are managed within a
            third party account while funds are disbursed into the school's
            designated account and not the student's private bank account.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Travel & Migration Payments
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay enables users to book flights, accommodation, and pay for
            migration services such as visa fees through trusted third-party
            partners.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Savings & Interest Account
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Users can save money in local and international currencies and earn
            interest based on prevailing rates. Savings terms and interest rates
            are transparently provided.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Insurance</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We facilitate access to travel, health, and life insurance through
            third-party insurance partners.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Utility Bill Payments
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Users can pay local utility bills (electricity, internet, airtime)
            and purchase gift cards using funds from their AfriPay wallet.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Lawful Use</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            You agree to use AfriPay only for lawful purposes and in accordance
            with all applicable laws and regulations, including anti-money
            laundering (AML) and counter-terrorism financing (CTF) laws.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
             Prohibited Activities
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            You agree NOT to use the Services to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Engage in any fraudulent or illegal transactions</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe intellectual property rights</li>
            <li>Conduct unauthorized scraping or data harvesting</li>
            <li>Transmit malware or harmful code</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Payment Fees
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay may charge transaction fees for tuition payments, loan
            processing, card issuance, currency exchange, and other services.
            All applicable fees will be disclosed at the time of transaction.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Currency Exchange
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Exchange rates are provided based on real-time data and may include
            a conversion margin. You agree to the rate provided at the time of
            your transaction.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Taxes</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            You are responsible for paying all applicable taxes arising from
            your use of the Services.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Data Security
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay uses industry-standard security protocols, including:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li> SSL/TLS encryption for data in transit</li>
            <li>AES-256 encryption for data at rest</li>
            <li>Role-Based Access Controls (RBAC)</li>
            <li>Regular security audits and compliance reviews</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Authentication
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Users are required to enable Two-Factor Authentication (2FA) using
            OTPs via SMS/email or authenticator apps.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Data Privacy
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Your personal information is processed in accordance with our
            Privacy Policy. By using the Services, you consent to the
            collection, use, and sharing of your information as described
            therein.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Blockchain and Smart Contracts
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay leverages blockchain technology for certain payment flows to
            ensure transparency, traceability, and fraud prevention.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Smart Contracts
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Certain transactions (e.g., tuition payments, loan disbursements)
            may be processed using smart contracts on Ethereum or Hyperledger
            networks. These contracts are immutable and tamper-proof.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Stablecoins</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We may support payments in stablecoins such as USDC or Tether for
            greater stability. Cryptocurrency payments are subject to additional
            KYC/AML verification.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Third-Party Services
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay integrates with third-party services, including:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li> Payment providers (e.g., Fincra, Korapay)</li>
            <li>Insurance providers</li>
            <li>Travel agencies</li>
            <li>Educational institutions</li>
            <li>Utility payment gateways</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We are not liable for the acts, omissions, or errors of these third
            parties. Use of such services is governed by their respective terms
            and policies.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">No Warranty</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay is provided "as is" without warranties of any kind. We do
            not guarantee:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Continuous or uninterrupted access to the Services</li>
            <li>Accuracy or timeliness of data</li>
            <li>Suitability for any particular purpose</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Limitation of Liability
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            To the maximum extent permitted by law, AfriPay shall not be liable
            for:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Any indirect, incidental, or consequential damages</li>
            <li>Loss of funds due to user error or third-party failures</li>
            <li>
              Unauthorized access due to your failure to safeguard credentials
            </li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Force Majeure
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We are not responsible for delays or failures caused by events
            beyond our control, including but not limited to natural disasters,
            internet outages, or government restrictions.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Suspension</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We may suspend your account if:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>You violate these Terms</li>
            <li>Suspicious activity is detected</li>
            <li>Required by regulatory authorities</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We are legally obligated to report any fraudulent activity to the
            appropriate local authorities.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Termination</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            You may terminate your account at any time by contacting
            technicalsupport@goafripay.com. Upon termination, access to the
            Services will be revoked, and any remaining funds will be settled as
            per our policy.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Governing Law and Dispute Resolution
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            This Privacy Policy is governed by the laws of the jurisdiction in
            which the fintech operates, with the Federal Republic of Nigeria
            serving as the primary governing law where applicable. Any disputes
            arising from this policy will be resolved through arbitration,
            conducted in Lagos, Nigeria, or in the relevant local jurisdiction,
            in compliance with the applicable arbitration laws, including the
            Nigerian Arbitration and Conciliation Act where Nigeria law applies.
            For users in other countries, the local laws and arbitration
            procedures of the respective jurisdiction may also apply as
            determined by the Fintech.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Updates to Terms
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We may modify these Terms from time to time. Any updates will be
            posted on our website and mobile app. Your continued use of the
            Services after any changes constitutes acceptance of the new Terms.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Contact Information
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            For inquiries, feedback, or complaints, please contact:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Email: technicalsupport@goafripay.com</li>
            <li>Phone: +234 906 178 1999</li>
            <li>Website: https://goafripay.com</li>
          </ul>
        </div>

        <div className="mt-10">
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Thank you for choosing AfriPay. We are committed to providing a
            secure, inclusive, and empowering financial platform for Africans
            across the world. Afripro Platform Nigeria Ltd
          </p>
        </div>

        {/* Terms of Service - formal content */}

        {/* <div>
                    <div>
                        <h1 className='text-[36px] font-bold'>Terms of Use</h1>

                        <h3 className='text-[20px] mt-2 text-[#6E7093]'>Last Updated: April 1, 2024</h3>
                    </div>

                    <p className='text-[16px] mt-3'>By accessing or using AfriPay's services, you agree to comply with these Terms of Use. Please read these terms carefully before using our platform.</p>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Acceptance of Terms</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>By accessing or using our platform, you agree to be bound by these Terms of Use and our Privacy Policy.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Use of Services</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>You must be at least 18 years old and legally capable of entering into contracts to use our services.</li>
                            <li>You agree to provide accurate and complete information when registering an account and using our platform.</li>
                            <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Intellectual Property</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>All content and materials on our platform, including logos, trademarks, and software, are owned or licensed by AfriPay and protected by intellectual property laws.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Prohibited Activities</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>You agree not to engage in any illegal, fraudulent, or unauthorized activities when using our platform.</li>
                            <li>You may not modify, adapt, reverse engineer, or decompile any part of our platform.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Limitation of Liability</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>AfriPay is not liable for any damages, losses, or liabilities arising from your use of our platform or services.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Governing Law</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>These Terms of Use are governed by the laws of [Your Country], without regard to its conflict of law provisions.</li>

                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Changes to this Agreement</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>We reserve the right to update or modify these Terms of Use at any time. Continued use of our platform after any changes constitutes acceptance of the revised terms.</li>

                        </ul>
                    </div>
                </div> */}
      </div>
      <Footer />
    </>
  );
}

export default TermsOfUse;
